import PropTypes from 'prop-types';

export const AppointmentInformation = ({ listItem }) => (
  <ul>
    <li>
      Please aim to arrive
      <strong> 5 minutes before </strong>
      your appointment time
    </li>
    {listItem}
  </ul>
);

AppointmentInformation.propTypes = {
  listItem: PropTypes.node.isRequired,
};
